import { css } from '@emotion/css'
import {
  spacing,
  borderRadius,
  fontFamily,
  fontSize,
  zIndex,
  spin,
  shorthandHelper,
  getThemeColors,
  colors,
  hexToRgba,
  scrollGradient,
} from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    position: 'relative',
    width: 240,
    fontFamily: fontFamily.body,
  }),

  field: css({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    height: 40,
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
  }),

  openField: css({
    zIndex: zIndex.level6,
  }),

  fieldError: css({
    borderColor: colors.mandy,

    '&:focus-within': {
      borderColor: colors.mandy,
      boxShadow: `0 0 0 2px ${hexToRgba(colors.mandy, 0.25)}`,
    },
  }),

  input: css({
    boxSizing: 'border-box',
    fontFamily: fontFamily.body,
    fontSize: fontSize.default,
    color: colors.jumbo,
    lineHeight: 1.2,
    padding: shorthandHelper([spacing.small, 44, spacing.small, spacing.default]),
    backgroundColor: 'transparent',
    border: 0,
    borderRadius: borderRadius.default,
    flex: 1,
    height: '100%',

    '&::placeholder': {
      fontFamily: fontFamily.body,
      color: colors.grayChateau,
      userSelect: 'none',
    },

    '&:focus': {
      outline: 'none',
    },

    '&[disabled]': {
      backgroundColor: colors.athensGray,
    },

    '::-webkit-search-cancel-button': {
      WebkitAppearance: 'none',
    },
  }),

  icon: css({
    position: 'absolute',
    right: 0,
    top: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    padding: shorthandHelper([0, spacing.default]),
    pointerEvents: 'none',
    background: 'none',
    border: 'none',

    '&:focus': {
      outline: 'none',
    },
  }),

  iconSpinning: css({
    animationName: spin,
    animationDuration: '2000ms',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
  }),

  iconClear: css({
    cursor: 'pointer',
    pointerEvents: 'auto',
  }),

  body: css({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'absolute',
    top: 40,
    left: 0,
    right: 0,
    maxHeight: 280,
    overflowY: 'auto',
    border: `1px solid ${colors.mystic}`,
    borderRadius: borderRadius.default,
    zIndex: zIndex.level6,
    marginTop: -2,
    borderTopRightRadius: 0,
    borderTopLeftRadius: 0,

    // Scroll gradient
    ...scrollGradient,

    '&:focus': {
      outline: 'none',
    },
  }),

  item: css({
    position: 'relative',
    userSelect: 'none',
    padding: spacing.default,
    fontSize: fontSize.default,
    color: colors.jumbo,
    cursor: 'pointer',

    '&[disabled]': {
      cursor: 'default',
      pointerEvents: 'none',
      color: colors.geyser,
    },
  }),
}

export default styles

export const fieldTheme = theme => {
  const themed = getThemeColors(theme)
  return css({
    '&:focus-within': {
      borderColor: themed.base,
      boxShadow: `0 0 0 2px ${hexToRgba(themed.base, 0.25)}`,
    },
  })
}

export const itemTheme = (theme, selected) => {
  const themed = getThemeColors(theme)
  return css({
    ...(selected && {
      backgroundColor: themed.light,
      color: themed.base,
    }),

    '&:focus': {
      outline: 'none',
      backgroundColor: colors.athensGray,
    },

    '&:hover': {
      backgroundColor: themed.light,
      color: themed.base,
    },
  })
}
